// Add DOM4 support, https://github.com/WebReflection/dom4
import 'dom4';
//bootstrap
import 'jquery'; 

//bootstrap
import 'bootstrap';

// Add Babel polyfill for ES2015, https://babeljs.io/docs/usage/polyfill/
import 'babel-polyfill';

//fontfaceobserver
import FontFaceObserver from 'fontfaceobserver';

 

//scroll bars
import SimpleBar from 'simplebar';

//match height  data-mh="my-group"
import matchHeight from 'jquery-match-height';





// Import all components from  UI library
import {
  Navi,
  JqeryFunction,
  slickslider,
  Validator,
  Gmaps
} from '../Js/index';


// ----------------------------------------------------------------------------
// Load SVG sprite with  Icons
// ----------------------------------------------------------------------------
Array.from(document.querySelectorAll('[data-svg-sprite]')).forEach(element => {
  const src = element.getAttribute('data-svg-sprite');
  if (typeof src === 'string' && src.length > 0) {
    let ajax = new XMLHttpRequest();
    ajax.open('GET', src, true);
    ajax.responseType = 'document';
    ajax.onload = function (event) {
      element.removeAttribute('data-src');
      try {
        element.appendChild(ajax.responseXML.documentElement);
      } catch (e) {
        console.log(e);
      }
    };
    ajax.send();
  }
});


// ----------------------------------------------------------------------------
// Update components after font ' Type' was loaded:
// ----------------------------------------------------------------------------
let fontFaceObserverScreen = new FontFaceObserver('Open Sans');
fontFaceObserverScreen.load().then(function () {

}, function () {
  // Error handling: Font is not available or timeout.
  console.warn('Warning: Open Sans not available.');
});

let fontFaceObserverExtended = new FontFaceObserver('Open Sans');
fontFaceObserverExtended.load().then(function () {

}, function () {
  // Error handling: Font is not available or timeout.
  console.warn('Warning: Open Sans not available.');
});



/** WEBPACK FOOTER **
 ** ./~/eslint-loader!./assets/temp/dev.js
 **/